module.exports = __webpack_public_path__ + "img/projek13.029cdaf4.png";